import React, { useState, JSX } from "react";
import { AnimatePresence, motion } from 'framer-motion';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faTimes } from "@fortawesome/free-solid-svg-icons";
import styles from './CampaignPopUp.module.scss';
import type { HedisPopUpConfig } from "interfaces/MemberPortalConfig";
export type CampaignPopUpProps = {
    alertType: 'danger' | 'warning' | 'info' | 'success';
    title: string;
    hedisConfig: HedisPopUpConfig;
    message: JSX.Element | string;
};

export function CampaignPopUp({alertType, title, message, hedisConfig}: CampaignPopUpProps) {
    const [showPopUp, setShowPopUp] = useState(true);

    function getIconColor() {
        switch(alertType) {
            case 'danger':
                return 'rgb(142.56, 60.8, 37.36)';
            case 'warning':
                return 'rgb(150.36, 119.56, 23.32)';
            case 'info':
                return 'rgb(29.72, 103.44, 115.36)';
            case 'success':
                return 'rgb(10, 54, 34)';
            default:
                return 'rgb(142.56, 60.8, 37.36)';
        }
    }

    function handleClickClose() {
        setShowPopUp(false);
    }

    return (
        <AnimatePresence>
            {showPopUp &&  <motion.article
                animate={{ scale: 1, opacity: 1}}
                initial={{ scale: 0.5, opacity: 0}}
            >
            <article className={`alert alert-${alertType} ${styles.alert}`} role="alert">
                <button type="button" className={`${styles['close-btn']}`} aria-label="Close" onClick={handleClickClose}>
                    <FontAwesomeIcon icon={faTimes} color={getIconColor()}/>
                </button>
                <p className={styles.title}>
                    <FontAwesomeIcon icon={faBell} className={styles['bell-icon']}/>
                    <strong>{title}</strong>
                </p>
                {message}
            </article>
            </motion.article>}
        </AnimatePresence>
    );
}
